// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"8f6d0e0d","272":"17dda25c","276":"d70e48ca","332":"92f9b184","422":"72925f90","453":"b9e64f82","545":"7d278f11","796":"3e300c84","843":"bb4a1382"}[chunkId] + ".chunk.js";
};